import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import CheckboxSvg from 'images/v5/icons/circle/checkbox.svg';
import ExclamationSvg from 'images/v5/icons/circle/exclamation.svg';
import InformationSvg from 'images/v5/icons/circle/information.svg';
import WarningSvg from 'images/v5/icons/circle/warning.svg';
import styles from './StatusBadge.module.scss';
function StatusBadge({ size = 's', shape = 'inline', theme = 'fill', color = 'neutral', to, onClick, noIcon = false, children, }) {
    const classes = classNames(styles.wrap, styles[size], styles[shape], styles[theme], styles[color], {
        [styles.clickable]: to || onClick,
    });
    const defaultIcons = {
        negative: React.createElement(ExclamationSvg, null),
        notice: React.createElement(WarningSvg, null),
        positive: React.createElement(CheckboxSvg, null),
        info: React.createElement(InformationSvg, null),
        neutral: React.createElement(InformationSvg, null),
    };
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    const content = (React.createElement(React.Fragment, null,
        !noIcon && defaultIcons[color],
        children && React.createElement("span", null, children)));
    if (to) {
        return (React.createElement(Link, { type: "button", role: "link", to: to, className: classes, onClick: handleClick }, content));
    }
    if (onClick) {
        return (React.createElement("button", { type: "button", className: classes, onClick: handleClick }, content));
    }
    return React.createElement("span", { className: classes }, content);
}
export default StatusBadge;
